import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { notificationService } from '../../../services/notificationService';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const TestNotificationPanel = () => {
  const { user, userProfile } = useAuth();
  const [email, setEmail] = useState(userProfile?.email || '');
  const [name, setName] = useState(userProfile?.fullName || '');
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSendTest = async (e) => {
    e?.preventDefault();
    try {
      setSending(true);
      setMessage(null);
      await notificationService?.sendTestNotification(email, name);
      setMessage({ 
        type: 'success', 
        text: `Email de test envoyé avec succès à ${email}` 
      });
    } catch (error) {
      console.error('Error sending test notification:', error);
      setMessage({ 
        type: 'error', 
        text: 'Erreur lors de l\'envoi de l\'email de test' 
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">Test de Notification Email</h3>
        <p className="text-muted-foreground">
          Envoyez un email de test pour vérifier que votre système de notifications fonctionne correctement.
        </p>
      </div>
      <form onSubmit={handleSendTest} className="space-y-4">
        <Input
          label="Nom du destinataire"
          type="text"
          value={name}
          onChange={(e) => setName(e?.target?.value)}
          placeholder="Entrez le nom"
          required
        />

        <Input
          label="Email du destinataire"
          type="email"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          placeholder="exemple@email.com"
          required
        />

        {/* Preview */}
        <div className="bg-muted/30 rounded-lg p-4 border border-border">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={20} className="text-primary" />
            </div>
            <div className="flex-1">
              <p className="font-medium text-foreground mb-1">Aperçu de l'email de test</p>
              <p className="text-sm text-muted-foreground">
                <strong>Destinataire:</strong> {name || 'Nom'} ({email || 'email@exemple.com'})
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Sujet:</strong> Test de Notification - ORAZEK
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                Ceci est un email de test pour vérifier que votre système de notifications fonctionne correctement.
              </p>
            </div>
          </div>
        </div>

        {/* Message */}
        {message && (
          <div className={`p-4 rounded-lg ${
            message?.type === 'success' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <div className="flex items-center gap-2">
              <Icon name={message?.type === 'success' ? 'CheckCircle' : 'XCircle'} size={20} />
              <span>{message?.text}</span>
            </div>
          </div>
        )}

        {/* Submit Button */}
        <Button type="submit" disabled={sending} className="w-full">
          {sending ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Envoi en cours...
            </>
          ) : (
            <>
              <Icon name="Send" size={20} className="mr-2" />
              Envoyer l'Email de Test
            </>
          )}
        </Button>
      </form>
      {/* Info Box */}
      <div className="mt-6 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="text-sm text-foreground">
            <p className="font-medium mb-1">Note importante</p>
            <p className="text-muted-foreground">
              L'email de test sera envoyé via le service Resend configuré dans votre projet. 
              Assurez-vous que votre clé API Resend est correctement configurée dans les variables d'environnement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestNotificationPanel;